<template lang="pug">
div.mylist--overlay(v-show="visibleSearchForm" @click.self="$emit('hide-search-form', needInitializeShowPage)")
  div.mylist--editor
    div.mylist--editor-search
      select.mylist--editor-condition.form-control(v-model='filterType', @change='searchGames')
        option(value='mygame') マイボードゲームから
        option(value='played') 経験ありのみ
        option(value='favorite') お気に入りのみ
        option(value='have') 持ってるのみ
        option(value='all') 全てのデータベースから
      div.mylist--editor-freeword.input-group
        input(
          type='text'
          name='game[name]'
          class='form-control'
          v-model='freeword'
          placeholder='例: カタン'
        )
        div.mylist--editor-submit.input-group-addon.btn.btn-primary(@click='searchGames') <i class="fa fa-search"></i>
      button.mylist--editor-close.btn.btn-default(@click="$emit('hide-search-form', needInitializeShowPage)") <i class="fa fa-close"></i>

    div.mylist--editor-result
      template(v-if="searching")
        div.mylist--editor-result-loading 読み込み中…
      template(v-else-if="games.length == 0")
        div.mylist--editor-result-empty 該当するボードゲームが見つかりません
      template(v-else)
        div.mylist--editor-result-item(v-for="game in games")
          div.mylist--editor-result-image
            img(:src="game.picture" :alt="game.name")
          div.mylist--editor-result-title {{game.name}}
          div.mylist--editor-result-action
            template(v-if="game.contained")
              button.btn.btn-default.btn-sm(@click="destroyMyListElement(game.id)" :disabled="game.processing") 削除
            template(v-else)
              button.btn.btn-primary.btn-sm(@click="createMyListElement(game.id)" :disabled="game.processing") 追加
    infinite-loading(spinner="waveDots" @infinite="infiniteHandler" :identifier="infiniteId" ref="infiniteLoading")
      span(slot="no-results")
      span(slot="no-more")

</template>

<script>
import InfiniteLoading from 'vue-infinite-loading';
import axios from 'common/axios';

export default {
  components: { InfiniteLoading },
  props: {
    visibleSearchForm: {
      type: Boolean,
      default: false
    },
    myListId: {
      type: Number,
      default: 0
    }
  },
  data: function() {
    return {
      games: [],
      page: 1,
      filterType: 'mygame',
      freeword: '',
      infiniteId: +new Date(),
      needInitializeShowPage: false,
      searching: false
    };
  },
  computed: {
    searchGamesPath: function() {
      return `/mypage/my_lists/${this.myListId}/search_games`;
    },
    createMyListElementPath: function () {
      return `/mypage/my_lists/${this.myListId}/elements`;
    },
    destroyMyListElementPath: function () {
      return `/mypage/my_lists/${this.myListId}/elements/destroy_by_params`;
    },
  },
  watch: {
    visibleSearchForm: function() {
      if (this.visibleSearchForm) {
        this.needInitializeShowPage = false;
        this.searchGames();
      }
    }
  },
  methods: {
    createMyListElement: async function (game_id) {
      let game = this.games.find((game) => game.id === game_id);
      this.$set(game, 'processing', true);
      await axios.post(this.createMyListElementPath, {
        listable_id: game_id,
        listable_type: 'Game'
      });
      this.$set(game, 'contained', true);
      this.$set(game, 'processing', false);
      this.$emit('change-my-list-size', this.myListId, 1);
      this.needInitializeShowPage = true;
    },
    destroyMyListElement: async function (game_id) {
      let game = this.games.find((game) => game.id === game_id);
      this.$set(game, 'processing', true);
      await axios.delete(this.destroyMyListElementPath, {
        params: {
          listable_id: game_id,
          listable_type: 'Game'
        }
      });
      this.$set(game, 'contained', false);
      this.$set(game, 'processing', false);
      this.$emit('change-my-list-size', this.myListId, -1);
      this.needInitializeShowPage = true;
    },
    searchGames: function() {
      this.games = [];
      this.page = 1;
      this.infiniteHandler(this.$refs.infiniteLoading.stateChanger);
    },
    infiniteHandler: function($state) {
      var params = { filterType: this.filterType, freeword: this.freeword, page: this.page };
      this.searching = true;
      axios.get(this.searchGamesPath, { params: params }).then(({ data }) => {
        if (data.games.length) {
          this.page == 1 ? this.games = data.games : this.games.push(...data.games);
          this.page += 1;
          $state.loaded();
          if (data.last_page) {
            $state.complete();
          }
        } else {
          $state.complete();
        }
      }).finally(() => {
        this.searching = false;
      });
    }
  },
};
</script>
